module.exports = __webpack_public_path__ + "onprem_70x70.5e05526b84decb735a4c46c552eeb73b.png";